import * as GetImageTypes from 'src/actions/image/get/Types';
import { GetImageAction, GetImageFailure, GetImageSuccess } from 'src/actions/image/get/GetImage.actions';

export interface GetImageState {
  image?: File;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetImageState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetImageReducer(state: GetImageState = initialState,
                                action: GetImageAction): GetImageState {
  switch (action.type) {
    case GetImageTypes.GET_IMAGE_ATTEMPT:
      return {...state, image: undefined, loading: true, error: false};
    case GetImageTypes.GET_IMAGE_SUCCESS:
      const image: File = (action as GetImageSuccess).payload;
      return {...state, image: image, loading: false, error: false};
    case GetImageTypes.GET_IMAGE_FAILURE:
      return {
        ...state,
        image: undefined,
        loading: false,
        error: true,
        errorMessage: (action as GetImageFailure).payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/image/GetImageReducer.tsx